import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import {
    Alerts,
    AlertsHistorical,
} from '../../../../../shared/types/legalProceedings/alerts';
import {
    asyncGetAlert,
    asyncGetAlertHistorical,
} from '../../../../../services/alerts.service';
import { ALERTS } from '../../../../../routes/paths';

export const useAlertsDetail = () => {
    const navigate = useNavigate();
    const { idAlert } = useParams();
    const [loading, setLoading] = useState(false);
    const [alert, setAlert] = useState<Alerts>();
    const [alertHistorical, setAlertHistorical] =
        useState<AlertsHistorical[]>();

    useEffect(() => {
        if (Boolean(idAlert?.trim())) {
            setLoading(true);
            asyncGetAlert(idAlert?.trim())
                .then((alert) => {
                    if (alert) setAlert(alert);
                    else navigate(ALERTS);
                })
                .finally(() => setLoading(false));
        }
    }, [idAlert]);

    useEffect(() => {
        if (Boolean(idAlert?.trim())) {
            setLoading(true);
            asyncGetAlertHistorical(idAlert?.trim())
                .then((resp) => {
                    if (resp) setAlertHistorical(resp);
                    else navigate(ALERTS);
                })
                .finally(() => setLoading(false));
        }
    }, [idAlert]);

    return { loading, alert, alertHistorical };
};
